import { css as t } from "../stitches.config.es.js";
const r = t({
  fontFamily: "Poppins",
  fontWeight: 600,
  background: "#e03e52",
  backgroundClip: "border-box",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent"
}), e = t({
  fontSize: "75%"
}), i = t({
  verticalAlign: "top",
  marginRight: 5
});
export {
  e as wprDecimalStyles,
  i as wprMarkStyles,
  r as wprStyles
};
//# sourceMappingURL=Wpr.styles.es.js.map
